import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'Guía de Pueblos Antiguos',
    price: 19,
    description: 'Descubre los pueblos y ciudades más importantes mencionados en la Biblia con reconstrucciones visuales detalladas.',
    image: 'https://cdn.magicpatterns.com/uploads/n9Xnu18Tac7wY36nb6ZCTm/20260225_1321_Image_Generation_simple_compose_01kjasn752fkcaamye3aerbje9.png'
  }, {
    id: 2,
    title: 'Cronología Bíblica Ilustrada',
    price: 29,
    description: 'Una línea de tiempo visual completa desde Génesis hasta Apocalipsis con los eventos más importantes ilustrados.',
    image: 'https://cdn.magicpatterns.com/uploads/n9Xnu18Tac7wY36nb6ZCTm/20260225_1321_Image_Generation_simple_compose_01kjasn752fkcaamye3aerbje9.png'
  }, {
    id: 3,
    title: 'Atlas de Mapas Bíblicos',
    price: 15,
    description: 'Colección de mapas detallados de cada período bíblico para entender la geografía de las Escrituras.',
    image: 'https://cdn.magicpatterns.com/uploads/n9Xnu18Tac7wY36nb6ZCTm/20260225_1321_Image_Generation_simple_compose_01kjasn752fkcaamye3aerbje9.png'
  }, {
    id: 4,
    title: 'Diccionario de Lugares Sagrados',
    price: 25,
    description: 'Referencia completa de todos los lugares mencionados en la Biblia con contexto histórico y arqueológico.',
    image: 'https://cdn.magicpatterns.com/uploads/n9Xnu18Tac7wY36nb6ZCTm/20260225_1321_Image_Generation_simple_compose_01kjasn752fkcaamye3aerbje9.png'
  }, {
    id: 5,
    title: 'Guía del Templo de Salomón',
    price: 19,
    description: 'Reconstrucción visual detallada del Templo de Salomón con explicaciones de cada área y su significado.',
    image: 'https://cdn.magicpatterns.com/uploads/n9Xnu18Tac7wY36nb6ZCTm/20260225_1321_Image_Generation_simple_compose_01kjasn752fkcaamye3aerbje9.png'
  }, {
    id: 6,
    title: 'Guía de Estudio Interactiva',
    price: 15,
    description: 'Herramienta de estudio paso a paso para profundizar en cada libro de la Biblia con el contexto visual.',
    image: 'https://cdn.magicpatterns.com/uploads/n9Xnu18Tac7wY36nb6ZCTm/20260225_1321_Image_Generation_simple_compose_01kjasn752fkcaamye3aerbje9.png'
  }, {
    id: 7,
    title: 'Actualizaciones de Por Vida',
    price: 0,
    description: 'Recibe todas las futuras actualizaciones y nuevas imágenes sin costo adicional. Para siempre.',
    image: 'https://cdn.magicpatterns.com/uploads/n9Xnu18Tac7wY36nb6ZCTm/20260225_1321_Image_Generation_simple_compose_01kjasn752fkcaamye3aerbje9.png'
  }];
  return <section className="py-8 md:py-16 bg-gradient-to-b from-navy-900 to-navy-800 text-white relative overflow-hidden content-section" data-id="element-57">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold-400 via-gold-200 to-gold-400" data-id="element-58"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-59">
        <div className="text-center mb-8 md:mb-16" data-id="element-60">
          <div className="inline-block bg-gold-600 text-white px-4 py-1 rounded-full text-sm font-bold mb-4 animate-pulse shadow-lg" data-id="element-61">
            OFERTA LIMITADA
          </div>
          <h2 className="font-heading text-2xl md:text-5xl font-bold text-white mb-4" data-id="element-62">
            Reclama Estos{' '}
            <span className="text-gold-400 highlight-burgundy" data-id="element-63">
              7 Bonos Exclusivos
            </span>{' '}
            Si Ordenas HOY
          </h2>
          <p className="text-base md:text-xl text-gray-300" data-id="element-64">
            Si entras hoy, te daré{' '}
            <span className="font-bold text-white" data-id="element-65">7 bonos especiales</span> por
            tiempo limitado…
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-8" data-id="element-66">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: Math.min(index * 0.1, 0.3),
          duration: 0.4
        }} className={`bg-navy-800 border border-navy-600 rounded-xl overflow-hidden hover:border-gold-500/50 transition-colors duration-300 flex flex-col ${index === bonuses.length - 1 ? 'col-span-2 w-full sm:w-1/2 mx-auto' : ''}`} data-id="element-67">
              {/* Image Area */}
              <div className="w-full aspect-[16/9] relative overflow-hidden bg-navy-900" data-id="element-68">
                <img src={bonus.image} alt={bonus.title} loading="lazy" width="600" height="338" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-69" />
              </div>

              {/* Content Area */}
              <div className="p-4 md:p-6 flex flex-col flex-grow" data-id="element-70">
                <div className="mb-2" data-id="element-71">
                  <span className="text-gold-500 font-bold text-sm tracking-wide block mb-1" data-id="element-72">
                    BONO #{bonus.id}:
                  </span>
                  <h3 className="font-heading text-xl font-bold text-white leading-tight" data-id="element-73">
                    {bonus.title}
                  </h3>
                </div>

                <p className="text-gray-400 text-sm leading-relaxed mb-3 md:mb-6 flex-grow" data-id="element-74">
                  {bonus.description}
                </p>

                <div className="mt-auto pt-4 border-t border-navy-700 flex items-center gap-3" data-id="element-75">
                  <span className="text-gray-500 line-through decoration-red-500 decoration-1 text-sm" data-id="element-76">
                    ${bonus.price > 0 ? bonus.price + '.00' : 'Invaluable'}
                  </span>
                  <span className="text-gray-600" data-id="element-77">—</span>
                  <span className="font-bold text-gold-400 text-lg tracking-wide" data-id="element-78">
                    ¡GRATIS!
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Total Value Box */}
        <div className="mt-8 md:mt-16 bg-gold-100 rounded-xl p-5 md:p-8 border-2 border-gold-400 text-center shadow-[0_0_30px_rgba(184,134,11,0.3)] max-w-3xl mx-auto" data-id="element-79">
          <p className="text-navy-900 font-bold uppercase tracking-widest mb-2 text-sm md:text-base" data-id="element-80">
            Valor Total de los Bonos:
          </p>
          <div className="flex items-center justify-center gap-4 mb-2" data-id="element-81">
            <span className="text-2xl md:text-4xl font-bold text-gray-400 line-through decoration-red-600 decoration-4 opacity-70" data-id="element-82">
              +$120 USD
            </span>
          </div>
          <p className="text-xl md:text-3xl font-bold text-burgundy-600 animate-pulse highlight-gold inline-block px-4" data-id="element-83">
            ¡TODOS GRATIS SI ORDENAS HOY!
          </p>
        </div>
      </div>
    </section>;
}